
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/librarians-resource",
      function () {
        return require("private-next-pages/librarians-resource.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/librarians-resource"])
      });
    }
  